import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function OurMission() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.2 });

    const items = document.querySelectorAll('.mission-fade');
    items.forEach((item, idx) => {
      item.style.transitionDelay = `${idx * 0.15}s`;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const s = {
    section: {
      padding: '8rem 6%',
      backgroundColor: '#FAF7F2',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    container: {
      maxWidth: '820px',
    },
    subtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.75rem',
      fontWeight: 700,
      letterSpacing: '0.18em',
      textTransform: 'uppercase',
      color: '#D96D29',
      marginBottom: '1rem',
    },
    title: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(2rem, 4vw, 3rem)',
      color: '#1C1209',
      lineHeight: 1.15,
      marginBottom: '2rem',
    },
    highlight: {
      fontStyle: 'italic',
      color: '#A0693A',
    },
    body: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1.05rem',
      lineHeight: 1.8,
      color: '#4A2C1A',
      marginBottom: '1.5rem',
    },
    quote: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1.4rem',
      fontStyle: 'italic',
      color: '#8B4224',
      lineHeight: 1.5,
      padding: '2rem',
      borderLeft: '3px solid #D96D29',
      textAlign: 'left',
      margin: '2.5rem 0',
    },
    ctaRow: {
      display: 'flex', gap: '1rem', justifyContent: 'center',
      flexWrap: 'wrap', marginTop: '2rem',
    },
  };

  return (
    <section id="mission" style={s.section}>
      <div style={s.container}>
        <div className="mission-fade preFade" style={s.subtitle}>Our Motivation</div>
        <h2 className="mission-fade preFade" style={s.title}>
          More Than Just A Cup.{' '}
          <span style={s.highlight}>It's About Impact.</span>
        </h2>
        
        <p className="mission-fade preFade" style={s.body}>
          At Savana Sips, our motivation stems from the profound impact coffee has on millions
          of lives — from the skilled farmers in Kenya who nurture volcanic soil into world-class
          specialty coffee, to the communities worldwide whose mornings are elevated by our roasts.
        </p>
        
        <blockquote className="mission-fade preFade" style={s.quote}>
          "Your Cup! Your Day! At Savana Sips — it's all about your coffee cup, your day.
          Every cup supports a farmer. Every day builds a community."
        </blockquote>

        <p className="mission-fade preFade" style={s.body}>
          We believe that bridging the gap between African origins and global markets doesn't
          mean sacrificing quality or ethics. Every purchase empowers local cooperatives,
          funds farmer education programs, and builds the franchise ecosystem that will create
          1,500+ jobs by 2030.
        </p>
        
        <div className="mission-fade preFade" style={s.ctaRow}>
          <Link to="/vision" className="btn-primary">Our Vision &amp; Goals →</Link>
          <Link to="/process" className="btn-secondary">See Our Process</Link>
        </div>
      </div>
    </section>
  );
}
